import React from 'react';

const NotFound = () => (
  <div>
    <h1>404 - Stran Ni Najdena</h1>
    <p>Stran, ki ste jo iskali ne obstaja.</p>
  </div>
);

export default NotFound;
